// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class MedicalBiPcp {
    'name'?: string;
    'phone'?: string;
    'referralFax'?: string;
    'referralWebsite'?: string;
    'referralAddress'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof MedicalBiPcp>> = [
        {
            "name":     "name",
            "baseName": "name",
            "type":     "string"
        },
        {
            "name":     "phone",
            "baseName": "phone",
            "type":     "string"
        },
        {
            "name":     "referralFax",
            "baseName": "referralFax",
            "type":     "string"
        },
        {
            "name":     "referralWebsite",
            "baseName": "referralWebsite",
            "type":     "string"
        },
        {
            "name":     "referralAddress",
            "baseName": "referralAddress",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return MedicalBiPcp.attributeTypeMap;
    }
}
